import type { FC } from 'react';
import type { CardProps } from '@mui/material';
import React from 'react';
import Link from './Link';
import {
  Card,
  CardContent,
  CardMedia,
  Typography
} from '@mui/material';

export interface ProjectCardProps extends CardProps {
  title?: string;
  body?: string;
  src?: string;
  href?: string;
}

const ProjectCard: FC<ProjectCardProps> = (props) => {
  const { title, body, src, href, ...params } = props;

  const card = (
    <Card
      sx={{
        ...href ? {
          '&:hover': {
            boxShadow: '0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1), 0 0 0 1px #485fc7'
          },
          '&:focus': {
            boxShadow: '0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1), 0 0 0 1px #485fc7'
          },
          '&:active': {
              boxShadow: 'inset 0 1px 2px rgba(10, 10, 10, 0.2), 0 0 0 1px #485fc7'
          }
        } : {}
      }}
      {...params}
    >
      {src && (
        <CardMedia
          component="img"
          src={src}
        />
      )}
      <CardContent>
        <Typography variant="h4" component="h2">{title}</Typography>
        <Typography variant="body2" color="textSecondary">
          {body}
        </Typography>
      </CardContent>
    </Card>
  );

  if (href) {
    return <Link to={href}>{card}</Link>;
  }

  return card;
};

export default ProjectCard;
